// color - основной цвет бренда для полоски
// value -
// mass
// levels
//      color
//      name
//      image
//          id
//          url

import ImageUrl from '../../../helpers/ImageUrl';
import cls from './Level.module.scss';
import _ from 'lodash';

function calculateLevel(value, mass, levels = []) {
    const scores = Math.max(0, Math.min(value, mass));
    if (scores === 0) return 1; // Минимальный балл по умолчанию 1 уровень
    const step = mass / levels.length;
    return Math.ceil(scores / step);
}

function pointsToNextLevel (value, mass, levels = []) {
    const scores = Math.max(0, Math.min(value, mass));
    if (levels.length === 0 || scores >= mass) return 0;

    const step = mass / levels.length;
    const currentLevel = Math.ceil(scores / step) || 1;

    // Находим целую границу следующего уровня
    // Используем Math.min(..., mass), чтобы не уйти выше максимума
    const nextLevelScoreThreshold = Math.min(Math.round(currentLevel * step), mass);

    const pointsLeft = nextLevelScoreThreshold - scores;

    // Если из-за округлений получилось 0, но мы еще не на максимуме,
    // значит до следующего уровня остался ровно 1 балл
    return pointsLeft <= 0 && scores < mass ? 1 : pointsLeft;}

export function Level ({color, value, mass, levels = [], min}) {
    const index = calculateLevel(value, mass, levels)
    let currentLevel = levels[index-1];

    const pos = Math.min(100, Math.round(value / mass * 100))

    // console.log('value', value);
    // console.log('mass', mass);
    // console.log('pos', pos);

    return (
        <div className={cls.card}>
            {(!min && currentLevel?.image) &&
                <img className={cls.image} src={ImageUrl(currentLevel?.image?.url)} alt={currentLevel?.name} />}
            <h3>{currentLevel?.name || 'Нет уровня'}</h3>
            <div className={cls.progress}>
                {_.map(levels, level => (
                    <div key={level.name} className={cls.level} style={{ backgroundColor: level.color }} />
                ))}
                <div className={cls.line} style={{ backgroundColor: color || '#2D68C4', left: `${pos}%` }} />
            </div>
            <div className={cls.caption}>{value} / {mass}</div>
            {pointsToNextLevel(value, mass, levels) > 0 && <div className={cls.caption}>До следующего уровня {pointsToNextLevel(value, mass, levels)} баллов</div> }

        </div>
    );
}